import { useState, useMemo } from 'react';
import { imagePickSize } from 'utils/general';
import clsx from 'clsx';
import Avatar from 'components/Avatar';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import APResponsiveDropdown from 'components/Dropdown/APResponsiveDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.scss';
import InputField from 'components/FormFields/InputField';

const undefinedAssignment = {
  profileImage: null,
  initials: '?',
  firstname: '(Unknown)',
};

const MemberAssignment = ({
  taskId,
  members,
  assignments,
  assignmentNote,
  onAdd,
  onRemove,
  onChangeNote,
}) => {
  const [showOrgMembers, toggleMemberDropdown] = useState(false);
  const assignmentMembers = useMemo(() => {
    return assignments.map((assignment) => {
      const foundMember = members.find(member => member.id === assignment.loginId);
      if (foundMember) return foundMember;
      return undefinedAssignment;
    });
  }, [members, assignments]);

  const assignableMembers = useMemo(() => {
    return members.filter((member) => member.canBeAssigned);
  }, [members, assignments]);

  const show = () => {
    toggleMemberDropdown(true);
  };

  const dismiss = () => {
    toggleMemberDropdown(false);
  };

  const renderAssignmentMenu = () => {
    return (
      <>
        {assignableMembers.map(member => {
          const isSelected = assignmentMembers.some(assignment => assignment.id === member.id);
          const profileImage = member.profileImage ?? null;
          const imagePath = profileImage
            ? `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${imagePickSize(profileImage,'square60')}`
            : null;
          const displayName = (member.firstname || member.lastname) ?
            [member.firstname, member.lastname].join(' ') :
            member.email;

          return (
            <button
              key={`lead-assignment--${member.id}`}
              className={clsx(
                'ap-dropdown__button',
                'ap-dropdown__button--task-assignment',
                'button--unstyled',
                { 'selected': isSelected },
              )}
              onClick={() => onAdd(member.id)}
            >
              <div className="inline-avatar">
                <div className="inline-avatar__image">
                  <Avatar
                    photo={imagePath}
                    text={!imagePath ? member.initials : null}
                    size={30}
                    borderSize={1}
                  />
                </div>
                <div className="inline-avatar__info">
                  {displayName}
                </div>
              </div>
            </button>
          );
        })}
      </>
    );
  };

  const trigger = (
    <DropdownButton className="button--unstyled button--assignment">
      Add
    </DropdownButton>
  );

  return (
    <>
      {assignmentMembers.length === 0 && (
        <>
          <div className="assigned-heading">Pre-Assignment</div>
          <InputField
            name={`pre-assignment--${taskId}`}
            label="Pre-Assignment"
            defaultValue={assignmentNote}
            onBlur={(e) => onChangeNote(e.target.value)}
            className="task__pre-assignment"
            placeholder="Add a note"
            showLabel={false}
          />
        </>
      )}
      <div className="assigned-heading">Assigned</div>
      {assignmentMembers.length ? (
        <div className="assigned-list">
          {assignmentMembers.map(member => (
            <div
              key={member.id}
              className="assigned-item"
            >
              <Avatar
                photo={
                  member.profileImage
                    ? `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${imagePickSize(member.profileImage, 'square60')}`
                    : null
                }
                text={!member.profileImage ? member.initials : null}
                size={30}
                borderSize={1}
              />
              <div className="assigned-item__name">
                {member.firstname} {member.lastname}
              </div>
              <div
                className="assigned-item__remove"
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(member.id);
                }}
              >
                <FontAwesomeIcon
                  icon={['fal', 'times']}
                  size="xs"
                />
              </div>
            </div>
          ))}
        </div>
      ) : null}
      <APResponsiveDropdown
        opened={showOrgMembers}
        show={show}
        dismiss={dismiss}
        triggerButton={trigger}
        placement="bottom-end"
        menuClass="assignment-data-dropdown"
        root={null}
      >
        {renderAssignmentMenu()}
      </APResponsiveDropdown>
    </>
  );
};

export default MemberAssignment;
